

export function LoadSpinner({ isVisible = true, color = "primary"}) {

    return (
        <div className={`spinner-border text-${color}`} role="status" style={{ visibility: isVisible ? 'visible' : 'hidden' }}>
            <span className="sr-only">Loading...</span>
        </div>
    );
}
